import * as React from 'react'
import {useEffect} from 'react'
import {authenticator, getBrowserBaseUrl} from '../../app/auth/SessionPlusAuthenticator'
import {kvPathOverview} from '../../kv/store/kv.paths'
import {digitalManzLoginRedirect} from '../store/digital.paths'

export const getKvRedirectUri = () => {
  return getBrowserBaseUrl() + kvPathOverview()
}

/**
 * Redirect URL for Manz (CP-1044)
 */
export const DigitalKVSManzRedirectPage = () => {
  useEffect(() => {
    if (authenticator.isAuthenticated()) {
      authenticator.logout(getBrowserBaseUrl() + digitalManzLoginRedirect())
    } else {
      const redirectUri = getKvRedirectUri()
      authenticator.login('MANZ', redirectUri)
    }
  }, [])

  return <div />
}
